export const heroImgURL = "https://cdn.cloudflare.steamstatic.com/";
export const heroIconURL =
  heroImgURL + "/apps/dota2/images/dota_react/heroes/icons/";
export const heroAnimURL =
  heroImgURL + "/apps/dota2/videos/dota_react/heroes/renders/";
export const landingPageVideoURL =
  "https://cdn.akamai.steamstatic.com/apps/dota2/videos/dota_react/homepage/dota_montage_webm.webm";
